import { Entity } from '@shared/entities/entity';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MachineAlarm')
export class MachineAlarm extends Entity {
  @JsonProperty('items', [String])
  public items: [string] = [''];
}
